import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/site";

const hotWords = ["联名秒空", "退票风波", "换角传闻", "直播翻车", "剪辑争议", "数据质疑"];

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20collage%20of%20stage%20spotlights%2C%20film%20strips%20and%20glowing%20screens%20in%20deep%20warm%20coral%20and%20amber%20tones%2C%20dramatic%20dark%20background%20with%20light%20beams%2C%20editorial%20entertainment%20magazine%20aesthetic%2C%20high%20contrast%2C%20moody%20atmospheric%20composition%2C%20high%20detail&width=1600&height=900&seq=gualine-hero-main-01&orientation=landscape"
          alt="瓜线热门吃瓜时间线主视觉"
          title="热门吃瓜时间线 - 瓜线"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      <div className="relative w-full px-4 md:px-8 pt-20 pb-16 md:pt-28 md:pb-24">
        <div className="mx-auto max-w-4xl text-center fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium text-background-100 backdrop-blur-sm">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line text-primary-300" />
            </span>
            热门吃瓜 · 时间线梳理 · 前因后果复盘
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl font-extrabold leading-tight text-background-50">
            热门吃瓜来龙去脉
            <span className="block mt-2 text-2xl md:text-4xl text-primary-200">
              一次看懂完整故事线
            </span>
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
            每个热点事件都按关键节点逐步拆解，理清复杂的人物关系与剧情反转。
            不再吃残瓜，从起因到收尾，把整条故事线一次看完。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/events"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600 cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-compass-3-line" />
              </span>
              进入事件库
            </Link>
            <a
              href="#hot-events"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors duration-200 hover:bg-background-50/20 cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-flashlight-line" />
              </span>
              看今日最热
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-background-300">正在升温：</span>
            {hotWords.map((word, idx) => (
              <Link
                key={word}
                to={`/events?q=${encodeURIComponent(word)}`}
                className="rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-xs text-background-100 transition-colors duration-200 hover:bg-primary-500 hover:border-primary-500 cursor-pointer"
              >
                {idx === 0 && <i className="ri-arrow-up-line mr-0.5" />}
                {word}
              </Link>
            ))}
          </div>
        </div>

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-6 md:grid-cols-4">
          {siteStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-xl md:text-2xl font-bold text-background-50">
                {stat.value}
              </div>
              <div className="mt-1 text-xs text-background-300">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}